// auth.guard.ts
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service'; // ajuste o caminho conforme necessário

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const token = sessionStorage.getItem('token');
    const tpUser = sessionStorage.getItem('tipoUser');
     
    if (token) {
      this.authService.setMostrarMenu(true);
      
      if (tpUser === 'U') {
        this.authService.setTipoUser(true);
      } else {
        this.authService.setTipoUser(false);
      }
      
      return true;
    }
    
    this.authService.setMostrarMenu(false);
    this.authService.setTipoUser(false);
    this.router.navigate(['/login']);
    return false;
  }
}
